import isEqualWith from 'lodash/isEqualWith';

export { default as deepEqual } from 'lodash/isEqual';

/**
 * Performs a shallow equality check on two values.
 *
 * @param   {any} a Left
 * @param   {any} b Right
 *
 * @returns {boolean}
 * @private
 */
export function shallowEqual(a, b) {
  return isEqualWith(a, b, (aval, bval, index) =>
    index === undefined ? undefined : Object.is(aval, bval)
  );
}
